import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  SimpleChanges
} from "@angular/core";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { FeaturesByPlanService } from "src/app/services/features-by-plan/features-by-plan.service";
import { SubFeatures } from "src/app/services/features-by-plan/interface/common";
import { GlobalVariable } from "../../app.component";
import { DataService } from "../../dataService/data.service";

// import

@Component({
  selector: "app-analytics-review-stats",
  templateUrl: "./analytics-review-stats.component.html",
  styleUrls: ["./analytics-review-stats.component.scss"],
})
export class AnalyticsReviewStatsComponent implements OnInit {
  @Output() redirect: EventEmitter<string> = new EventEmitter();

  public loading = false;
  private BASE_URL = GlobalVariable;
  outlet_id: any;
  searchText: String;
  p: number = 1;
  collection: any = [];
  collection1: any = [];
  sms_sent: any = [];
  email_sent: any = [];
  qrcode_sent: any = [];
  whatsapp_sent: number;
  item_list: any = [];
  show_stats: boolean = true;
  revreqtit = "Invites by Channel";
  role: string = this.storage.get("role");
  manager_list: any;
  channel_list: any;
  followed_list: any;
  team: string = "";
  channel: string = "";
  is_followed: string = "";
  @Input() is_whatsapp_connected: string = "false";
  reviewFeatures: any;
  requestChannels: string[] = [];
  private _analyticsData: any;

  @Input()
  set analyticsData(value) {
    this._analyticsData = value;
  }
  get analyticsData() {
    return this._analyticsData;
  }

  constructor(
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private HttpService: DataService,
    private featuresByPlan: FeaturesByPlanService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.analyticsData &&
      changes.analyticsData.currentValue !== undefined
    ) {
      let analyticsData = changes.analyticsData.currentValue;
      this.analyticsData = analyticsData;
      this.getInvitesByChannel();
    }
  }

  getInvitesByChannel() {
    this.collection1 = this.analyticsData["total_review_request"];
    this.sms_sent = this.analyticsData["total_sent_sms"];
    this.email_sent = this.analyticsData["total_sent_email"];
    this.qrcode_sent = this.analyticsData["total_qr_code"];
    this.whatsapp_sent = this.analyticsData["total_sent_whatsapp"];
  }

  ngOnInit() {
    this.getInvitesByChannel();
    this.getFeatures();
  }

  async getFeatures() {
    let reviewFeatures: SubFeatures = await this.featuresByPlan.getFeatures(
      "feature_reviews"
    );
    this.reviewFeatures = reviewFeatures.plan_subfeatures;
    this.requestChannels =
      this.reviewFeatures.review_invite_channel.values !== null &&
      Object.keys(this.reviewFeatures.review_invite_channel.values);
    return;
  }
}
